<template>
  <div id="keyFocusProjects">
		<ProjectList
			v-if="!detailShow"
			:searchForm="searchForm"
			:showMoreSearch="showMoreSearch"
			:businessTypeList="businessTypeList"
			:projectLevelList="projectLevelList"
			:boolOptions="boolOptions"
			:slaList="slaList"
			:representativeOfficeList="representativeOfficeList"
			:industryList="industryList"
			:subIndustryList="subIndustryList"
			:hwDeliveryCountryList="hwDeliveryCountryList"
			:svcDeliveryCountryList="svcDeliveryCountryList"
			:tier1PartnerList="tier1PartnerList"
			:tier1PartnerLoading="tier1PartnerLoading"
			:tableData="tableData"
			:tableLoading="tableLoading"
			:currentPage="currentPage"
			:pageSize="pageSize"
			:totalCount="totalCount"
			:exportLoading="exportLoading"
			@change-more-search="changeMoreSearch"
			@search="handleSearch"
			@reset="handleReset"
			@search-tier1-partner="handleTier1PartnerSearch"
			@change-page-size="changePageSize"
			@change-page="changePage"
			@download-template="handleDownloadTemplate"
			@batch-upload="handleBatchUpload"
			@export="handleExport"
			@open-detail="openDetail"
		/>

		<ProjectDetail
			v-if="detailShow"
			:detailData="detailData"
			:detailLoading="detailLoading"
			:processData="processData"
			:riskItems="riskItems"
			:businessTypeList="businessTypeList"
			:projectLevelList="projectLevelList"
			:representativeOfficeList="representativeOfficeList"
			:industryList="industryList"
			:subIndustryList="subIndustryList"
			:hwDeliveryCountryList="hwDeliveryCountryList"
			:svcDeliveryCountryList="svcDeliveryCountryList"
			:tier1PartnerList="tier1PartnerList"
			:slaList="slaList"
			:projectStatusList="projectStatusList"
			:detailPartnerList="detailPartnerList"
			:detailPartnerLoading="detailPartnerLoading"
			@save="handleSave"
			@back="closeDetail"
			@search-partner-name="handleDetailPartnerSearch"
		/>

		<el-dialog title="Batch Upload" :visible.sync="uploadDialogVisible" width="500px" :close-on-click-modal="false">
			<el-upload
				ref="uploadRef"
				action=""
				:auto-upload="false"
				:limit="1"
				accept=".xlsx,.xls"
				:on-change="handleFileChange"
				:on-remove="handleFileRemove"
				:file-list="uploadFileList"
			>
				<el-button size="small" type="primary">Select File</el-button>
				<div slot="tip" class="el-upload__tip">Only .xlsx / .xls files are accepted</div>
			</el-upload>
			<div slot="footer">
				<el-button size="small" @click="uploadDialogVisible = false">Cancel</el-button>
				<el-button size="small" type="primary" :loading="uploadLoading" @click="submitUpload">Upload</el-button>
			</div>
		</el-dialog>

		<!-- Import Result 弹窗 -->
		<el-dialog :visible.sync="importResultDialogVisible" width="500px" :close-on-click-modal="false" custom-class="import-result-dialog" :show-close="false">
			<div class="import-result-header">
				<i class="el-icon-warning" style="color:#E6A23C;font-size:18px;margin-right:6px;"></i>Successfully imported <strong>{{ importResultSuccessCount }}</strong> rows, <strong>{{ importResultFailCount }}</strong> rows failed:
			</div>
			<div>
				<div v-for="(e, idx) in importResultErrorList" :key="idx" class="import-result-error-line">Row {{ e.row }}: {{ e.message }}</div>
			</div>
			<div slot="footer">
				<el-button size="small" type="primary" @click="importResultDialogVisible = false">OK</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import moment from 'moment'
	import ProjectList from './ProjectList.vue'
	import ProjectDetail from './ProjectDetail.vue'
  export default {
    name: 'keyFocusProjects',
		components: { ProjectList, ProjectDetail },
    created () {
			this.initMockData()
			this.initLovData()
			this.initBusinessTypeList()
			this.initConfigData()
			this.handleSearch(true)
    },
    data () {
      return {
				moment,
				businessTypeList: [],
				projectLevelList: [],
				projectStatusList: [],
				boolOptions: [],
				slaList: [],
				representativeOfficeList: [],
				industryList: [],
				subIndustryList: [],
				hwDeliveryCountryList: [],
				svcDeliveryCountryList: [],
				tier1PartnerList: [],
				tier1PartnerLoading: false,
        searchForm: {},
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 0,
				exportLoading: false,
				detailShow: false,
				detailId: '',
				detailData: {},
				detailLoading: false,
				detailPartnerList: [],
				detailPartnerLoading: false,
				processData: [],
				riskItems: [],
				showMoreSearch: false,
				uploadDialogVisible: false,
				uploadLoading: false,
				uploadFileList: [],
				importResultDialogVisible: false,
				importResultErrorList: [],
				importResultSuccessCount: 0,
				importResultFailCount: 0,
      }
    },
    methods: {
			initMockData() {
				this.boolOptions = [
					{ labelKey: true, labelValue: 'Yes' },
					{ labelKey: false, labelValue: 'No' },
				]
			},
			initBusinessTypeList() {
				const url = `${this.$store.state.islhurl}projectManager/selectDataByType?type=businessType`
				this._get(url).then(res => {
					if (res.data) {
						this.businessTypeList = (res.data || []).map(item => ({ labelKey: item.value, labelValue: item.label }))
					}
				}).catch(() => {})
			},
			initLovData() {
				const lovCodes = 'HPFM.INDUSTRY,HPFM.SUB_INDUSTRY,HPFM.OVERSEA_COUNTRY,H3CPJ.PROJECT_MAINTENANCE_SERVICE'
				const url = `${this.$store.state.islhurl}lov/ipms/options?lovCodes=${encodeURIComponent(lovCodes)}`
				this._get(url).then(res => {
					if (res.code === 200 && res.data) {
						const data = res.data
						const sortByOrder = (arr) => (arr || []).sort((a, b) => (a.orderSeq || 0) - (b.orderSeq || 0))
						this.industryList = sortByOrder(data['HPFM.INDUSTRY'])
						this.subIndustryList = sortByOrder(data['HPFM.SUB_INDUSTRY'])
						const countryList = sortByOrder(data['HPFM.OVERSEA_COUNTRY'])
						this.representativeOfficeList = countryList
						this.hwDeliveryCountryList = countryList
						this.svcDeliveryCountryList = countryList
						const slaArr = sortByOrder(data['H3CPJ.PROJECT_MAINTENANCE_SERVICE'])
						this.slaList = slaArr.map(item => ({ labelKey: item.value, labelValue: item.meaning }))
					}
				}).catch(() => {})
			},
			initConfigData() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`
				const configKeyList = ['majorProjectLevel', 'projectStatus']
				let str = ''
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`
				})
				url = url + str.substring(1)
				this._post(url).then(res => {
					if (res.data && res.code === 200) {
						this.projectLevelList = res.data.majorProjectLevel || []
						this.projectStatusList = res.data.projectStatus || []
					}
				}).catch(() => {})
			},
			handleSearch(resetPage) {
				if (resetPage) {
					this.currentPage = 1
				}
				this.tableLoading = true
				const params = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
				}
				const form = this.searchForm
				Object.keys(form).forEach(key => {
					if (form[key] != null && form[key] !== '') {
						params[key] = form[key]
					}
				})
				// 手动拼接 query 参数（因为 _get 会 JSON.stringify params）
				let url = `${this.$store.state.islhurl}project-digital-brain/list?`
				Object.keys(params).forEach(key => {
					url += `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}&`
				})
				url = url.replace(/&$/, '')
				this._get(url).then(res => {
					this.tableLoading = false
					if (res.code === 200) {
						this.totalCount = res.totalSize || 0
						this.tableData = res.data || []
					} else {
						this.tableData = []
						this.totalCount = 0
						this.$message.error(res.msg || 'Query failed!')
					}
				}).catch(() => {
					this.tableLoading = false
					this.tableData = []
					this.totalCount = 0
				})
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch(true);
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
				this.handleSearch(true);
			},
			handleDownloadTemplate() {
				this.$axios({
					url: `${this.$store.state.islhurl}project-digital-brain/template/download`,
					method: 'get',
					responseType: 'blob',
				}).then(response => {
					const blob = new Blob([response.data])
					const aEle = document.createElement('a')
					const href = window.URL.createObjectURL(blob)
					aEle.href = href
					aEle.download = 'ProjectDigitalBrain_ImportTemplate.xlsx'
					document.body.appendChild(aEle)
					aEle.click()
					document.body.removeChild(aEle)
					window.URL.revokeObjectURL(href)
				}).catch(() => {
					this.$message.error('Download template failed!')
				})
			},
			handleBatchUpload() {
				this.uploadFileList = []
				this.uploadDialogVisible = true
			},
			handleFileChange(file, fileList) { // eslint-disable-line
				this.uploadFileList = fileList
			},
			handleFileRemove() {
				this.uploadFileList = []
			},
			submitUpload() {
				if (!this.uploadFileList.length) {
					this.$message.warning('Please select a file first!')
					return
				}
				this.uploadLoading = true
				const fd = new FormData()
				fd.append('file', this.uploadFileList[0].raw)
				const url = `${this.$store.state.islhurl}project-digital-brain/import`
				this._post(url, fd).then(res => {
					this.uploadLoading = false
					if (res.code === 200) {
						const data = res.data || {}
						this.uploadDialogVisible = false
						if (data.failCount > 0) {
							this.importResultErrorList = data.errorList || []
							this.importResultSuccessCount = data.successCount
							this.importResultFailCount = data.failCount
							this.importResultDialogVisible = true
						} else {
							this.$message.success(`Successfully imported ${data.successCount} rows!`)
						}
						this.handleSearch(true)
					} else {
						this.$message.error(res.msg || 'Import failed!')
					}
				}).catch(() => {
					this.uploadLoading = false
					this.$message.error('Import failed!')
				})
			},
			handleExport() {
				this.exportLoading = true
				const form = this.searchForm
				const params = {}
				Object.keys(form).forEach(key => {
					if (form[key] != null && form[key] !== '') {
						params[key] = form[key]
					}
				})
				this.$axios({
					url: `${this.$store.state.islhurl}project-digital-brain/export`,
					method: 'get',
					params,
					responseType: 'blob',
				}).then(response => {
					this.exportLoading = false
					const blob = new Blob([response.data])
					const aEle = document.createElement('a')
					const href = window.URL.createObjectURL(blob)
					aEle.href = href
					aEle.download = `ProjectDigitalLedger_${moment().format('YYYYMMDD')}.xlsx`
					document.body.appendChild(aEle)
					aEle.click()
					document.body.removeChild(aEle)
					window.URL.revokeObjectURL(href)
				}).catch(() => {
					this.exportLoading = false
					this.$message.error('Export failed!')
				})
			},
			openDetail(record) {
				this.detailShow = true
				this.detailLoading = true
				this.processData = []
				this.riskItems = []
				const projectNumber = record.projectNumber
				const detailUrl = `${this.$store.state.islhurl}project-digital-brain/detail/${projectNumber}`
				const processUrl = `${this.$store.state.islhurl}project-digital-brain/process/${projectNumber}`
				const riskUrl = `${this.$store.state.islhurl}project-digital-brain/risk/${projectNumber}?pageNum=1&pageSize=100`
				this._get(detailUrl).then(res => {
					this.detailLoading = false
					if (res.code === 200) {
						const data = res.data || {}
						const boolStringFields = ['ibService', 'attachServiceIncluded', 'whiteListAccount', 's3s2sProject', 'framework', 'projectDeliveryByPartner', 'ifEarlyShipment', 'ifCompetitorSubstitution', 'projectSummaryReport', 'mgmtCheckByH3c']
						boolStringFields.forEach(key => {
							if (data[key] === 'Yes') data[key] = true
							else if (data[key] === 'No') data[key] = false
						})
						this.detailData = data
						this.detailId = data.projectNumber
						// 默认进详情时，根据country和partnerName自动加载Partner下拉
						if (data.country || data.partnerName) {
							this.handleDetailPartnerSearch(data.partnerName || '', data.country)
						}
					} else {
						this.$message.error(res.msg || 'Failed to load detail!')
						this.detailData = {}
					}
				}).catch(() => {
					this.detailLoading = false
					this.detailData = {}
				})
				this._get(processUrl).then(res => {
					if (res.code === 200) {
						this.processData = (res.data && res.data.stages) || []
					}
				}).catch(() => {
					this.processData = []
				})
				this._get(riskUrl).then(res => {
					if (res.code === 200) {
						this.riskItems = res.data || []
					} else {
						this.$message.error(res.msg || 'Failed to load risk data!')
						this.riskItems = []
					}
				}).catch(() => {
					this.$message.error('Risk API request failed!')
					this.riskItems = []
				})
			},
			closeDetail() {
				this.detailShow = false;
				this.detailId = '';
				this.detailData = {};
				this.processData = [];
				this.riskItems = [];
				this.detailPartnerList = [];
			},
			handleSave() {
				const editableFields = ['ifEarlyShipment', 'ifCompetitorSubstitution', 'projectStatus', 'projectSummaryReport', 'projectDeliveryByPartner', 'country', 'partnerCode', 'namedEngineerJqcMatch', 'mgmtCheckByH3c']
				const params = { projectsNumber: this.detailData.projectNumber }
				editableFields.forEach(key => {
					if (this.detailData[key] != null && this.detailData[key] !== '') {
						params[key] = this.detailData[key]
					}
				})
				// Risk Level & Items
				if (this.riskItems && this.riskItems.length > 0) {
					params.riskItemList = this.riskItems.map(item => ({
						id: item.id || null,
						riskLevel: item.riskLevel || '',
						status: item.status || '',
						riskDescription: item.riskDescription || '',
					}))
				}
				const url = `${this.$store.state.islhurl}project-digital-brain/update`
				this._post(url, params).then(res => {
					if (res.code === 200) {
						this.$message.success('Save successful!')
					} else {
						this.$message.error(res.msg || 'Save failed!')
					}
				}).catch(() => {
					this.$message.error('Save failed!')
				})
			},
			changeMoreSearch() {
				this.showMoreSearch = !this.showMoreSearch;
			},
			handleTier1PartnerSearch: (function() {
				let timer = null
				return function(query) {
					if (timer) clearTimeout(timer)
					if (!query || !query.trim()) {
						this.tier1PartnerList = []
						return
					}
					timer = setTimeout(() => {
						this.tier1PartnerLoading = true
						const url = `${this.$store.state.islhurl}prm-partner/suggest?keyword=${encodeURIComponent(query.trim())}&limit=20`
						this._get(url).then(res => {
							this.tier1PartnerLoading = false
							if (res.code === 200) {
								this.tier1PartnerList = res.data || []
							} else {
								this.tier1PartnerList = []
							}
						}).catch(() => {
							this.tier1PartnerLoading = false
							this.tier1PartnerList = []
						})
					}, 300)
				}
			})(),
			handleDetailPartnerSearch: (function() {
				let timer = null
				return function(query, businessTerritory) {
					if (timer) clearTimeout(timer)
					if ((!query || !query.trim()) && !businessTerritory) {
						this.detailPartnerList = []
						return
					}
					timer = setTimeout(() => {
						this.detailPartnerLoading = true
						let url = `${this.$store.state.islhurl}prm-partner/suggest?limit=20`
						if (query && query.trim()) {
							url += `&keyword=${encodeURIComponent(query.trim())}`
						}
						if (businessTerritory) {
							url += `&businessTerritory=${encodeURIComponent(businessTerritory)}`
						}
						this._get(url).then(res => {
							this.detailPartnerLoading = false
							if (res.code === 200) {
								this.detailPartnerList = res.data || []
								// 详情回显：如果 detailData 有 partnerName 但没有 partnerCode，从搜索结果中反查回填
								if (this.detailData.partnerName && !this.detailData.partnerCode) {
									const matched = this.detailPartnerList.find(item => item.companyName === this.detailData.partnerName)
									if (matched) {
										this.$set(this.detailData, 'partnerCode', matched.partnerCode)
									}
								}
							} else {
								this.detailPartnerList = []
							}
						}).catch(() => {
							this.detailPartnerLoading = false
							this.detailPartnerList = []
						})
					}, 300)
				}
			})(),
		},
  }
</script>
<style lang="less" scoped>
#keyFocusProjects {
	/deep/.el-table .cell {
		word-break: break-word;
	}
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 0px;
			padding: 0 15px 0 0;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 0px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
				left: auto;
				right: 10px;
			}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
}
</style>
<style lang="less">
.import-result-dialog {
	display: flex;
	flex-direction: column;
	margin: 0 !important;
	position: absolute !important;
	top: 50% !important;
	left: 50% !important;
	transform: translate(-50%, -50%) !important;
	.import-result-dialog .el-dialog__body {
		padding: 0px 20px;
	}
	.import-result-header {
		margin-bottom: 12px;
		font-size: 14px;
	}
	.import-result-error-line {
		line-height: 1.8;
		font-size: 13px;
		color: #606266;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/keyFocusProjects/index.vue